<template>
    <div>
        <span style="display:inline-block; margin-bottom:0px;">
            <label style="margin-bottom:1px;"><strong>Addresses</strong></label><br/>
        </span>   
        <b-row v-for="address in value" :key="address.id">
            <b-col cols="10">
                <strong>{{address.addressType.description}}:</strong>
                {{address.streetAddress}} {{address.city}},
                <span v-if="!international">
                    {{address.state}}   {{address.postalCode}}
                </span><span v-if="international">
                    {{address.stateProv}}   {{address.postalCode}}, {{opts.countryOptions.find(c => c.value === address.country).text}}
                </span>
            </b-col>
            <b-col cols="2" v-if="address.changeDate != null">
                <BaseTextOutput label="Date Changed" :value="address.changeDate"/>
            </b-col>
            <b-col cols="2" v-if="address.removedDate != null">
                <BaseTextOutput label="Date Removed" :value="address.removedDate"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { commonOptions } from '@/mixins/commonOptions.js'

export default {
    props: {
        value: Array,
        international: Boolean
    },
    mixins: [
        commonOptions
    ],
}
</script>

<style>
</style>
